module.exports = __webpack_public_path__ + "img/icon7.055fd832.png";